import { provideRouter, Routes } from '@angular/router';
import { PropertiesOrOnboardedGuardService } from '@core/properties-or-onboarded-guard.service';
import { AuthGuardService } from './core/auth-guard.service';
import { OnboardedGuardService } from './core/onboarded-guard.service';

export const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuardService],
    loadComponent: () => import('./home/home.component').then(m => m.HomeComponent),
  },
  {
    path: 'home',
    canActivate: [AuthGuardService],
    loadComponent: () => import('./home/home.component').then(m => m.HomeComponent),
  },
  { path: 'landing', loadComponent: () => import('./landing/landing.component').then(m => m.LandingComponent) },
  { path: 'landing/:login', loadComponent: () => import('./landing/landing.component').then(m => m.LandingComponent) },
  { path: 'logout', loadComponent: () => import('./logout/logout.component').then(m => m.LogoutComponent) },
  {
    path: 'transactions',
    canActivate: [AuthGuardService, OnboardedGuardService],
    loadChildren: () => import('./transactions/transactions.routes').then(m => m.transactionsRoutes),
  },
  {
    path: 'user',
    loadChildren: () => import('./user/user.routes').then(m => m.userRoutes),
  },
  {
    path: 'properties',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./properties/properties.routes').then(m => m.propertiesRoutes),
  },
  {
    path: 'account',
    canActivate: [AuthGuardService, PropertiesOrOnboardedGuardService],
    loadChildren: () => import('./account/account.routes').then(m => m.accountRoutes),
  },
  {
    path: 'cards',
    redirectTo: 'bueno-cards',
    pathMatch: 'full',
  },
  {
    path: 'bueno-cards',
    canActivate: [AuthGuardService, OnboardedGuardService],
    loadChildren: () => import('./cards/cards.routes').then(m => m.cardsRoutes),
  },
  {
    path: 'succesfuly-pin-changed',
    loadComponent: () =>
      import('./shared/components/pin-changed/pin-changed.component').then(m => m.PinChangedComponent),
  },
  {
    path: 'payments',
    loadChildren: () => import('./payments/payments.routes').then(m => m.paymentsRoutes),
  },
  {
    path: 'onboarding',
    canActivate: [AuthGuardService],
    loadComponent: () => import('./onboarding/onboarding.component').then(m => m.OnboardingComponent),
  },
  {
    path: 'direct-debit',
    canActivate: [AuthGuardService, OnboardedGuardService],
    loadChildren: () => import('./direct-debits/direct-debits.routes').then(m => m.directDebitsRoutes),
  },
  { path: '404', loadComponent: () => import('./shared/components').then(m => m.PageNotFoundComponent) },
  { path: '**', redirectTo: '404' },
];

export const appRouting = provideRouter(routes);
